var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.preOrderBackerStage === "grace-period" ||
    _vm.preOrderBackerStage === "shutoff"
    ? _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass: "button accent block margin-top-xl margin-bottom-0",
              attrs: { to: { name: "plans" } },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-sm",
                attrs: { icon: _vm.$v6.regular.faRocketLaunch, size: "lg" },
              }),
              _vm._v("\n    Start a Subscription\n  "),
            ],
            1
          ),
        ],
        1
      )
    : _vm.autoRenew && _vm.$dt.isBraintree
    ? _c("div", [
        _c(
          "button",
          {
            staticClass: "button accent block margin-top-xl",
            on: {
              click: function ($event) {
                return _vm.$emit("setup-auto-renew")
              },
            },
          },
          [_vm._v("\n    Set Up Auto-Renew!\n  ")]
        ),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "and don't worry about losing access to services and Pro features"
          ),
        ]),
      ])
    : _vm.canReactivate
    ? _c(
        "div",
        [
          _c(
            "site-link",
            {
              staticClass: "button warning block margin-top-xl margin-bottom-0",
              attrs: { to: { name: "plans" } },
            },
            [_vm._v("\n    Pick a Plan + Reactivate!\n  ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }